<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    
    <!-- <transition name="zoom-fade" mode="out-in">
      <router-view></router-view>
    </transition> -->

    <!-- No page renders (or fetches data) until login has fully completed —
         opening any deep link (e.g. from a notification email) shows this
         loader through the sign-in handshake, then the requested page. -->
    <div v-if="!$store.state.authReady" class="auth-gate">
      <b-spinner variant="primary" label="Signing in"></b-spinner>
      <p class="auth-gate-text">Signing you in…</p>
    </div>
    <router-view v-else></router-view>

  </div>
</template>

<script>

export default {
  async mounted() {
  },
  data() {
        return {
        }
    },
  created() {
    },
  methods: {
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";
// .zoom-fade-enter-active, .zoom-fade-leave-active {
//   transition: transform 0.5s ease, opacity 0.5s ease;
// }
// .zoom-fade-enter, .zoom-fade-leave-to {
//   transform: scale(0.9);
//   opacity: 0;
// }
// .zoom-fade-enter-to, .zoom-fade-leave {
//   transform: scale(1);
//   opacity: 1;
// }
:root{
  --btn-color: rgb(118, 80, 137);
}

.auth-gate {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.auth-gate-text {
  color: #6b7280;
  font-size: 0.95rem;
  margin: 0;
}
*{
  font-size: 16px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
